import type { AdResult, AdShowParams, RewardedResult } from "../types";
import type { Transport } from "../transport";

/**
 * Реклама. Все методы возвращают результат со статусом.
 * Если реклама не настроена на платформе или юзер Premium — получим
 * `shown: false, reason: "premium" | "not_configured"`.
 *
 * Игра должна уметь graceful-degrade: если `shown: false`, давать игроку награду
 * через другой механизм (или не давать для interstitial).
 */
export function createAds(t: Transport) {
  return {
    /**
     * Показать interstitial. Блокирующая — игра на паузе до закрытия рекламы.
     * Рекомендуется между уровнями, а не посреди геймплея.
     */
    showInterstitial(params: AdShowParams = {}): Promise<AdResult> {
      return t.request<AdResult>("ads.showInterstitial", params);
    },

    /**
     * Показать rewarded видео. Игрок нажимает «посмотреть рекламу за награду»,
     * смотрит 15-30 сек, затем вы даёте награду.
     *
     * Gate-паттерн: ВСЕГДА проверяй `result.rewarded === true` перед выдачей награды.
     */
    showRewarded(params: AdShowParams = {}): Promise<RewardedResult> {
      return t.request<RewardedResult>("ads.showRewarded", params);
    },

    /**
     * Показать preroll (рекламу перед запуском игры).
     * Обычно вызывается один раз при `init()`, до старта геймплея.
     * Platform сама решает показывать или нет (frequency cap, premium).
     */
    showPreroll(params: AdShowParams = {}): Promise<AdResult> {
      return t.request<AdResult>("ads.showPreroll", params);
    },
  };
}

export type AdsApi = ReturnType<typeof createAds>;
